function UserUnlock(aId) {
    this.__type = "UserUnlock:www.veritracks.com";
    this.Id = aId;
}
if (typeof exports !== 'undefined') {
    module.exports = UserUnlock;
}